import type { Product } from "@/contexts/product-context"
import { solidTileGlyphIcon } from "@/lib/product-glyph"

/** Workspace record hub surfaced in the switcher instead of a product name. */
export type WorkspaceRecordContext = {
  id: "people-students" | "people-faculty"
  label: string
  product: Product
  icon: string
}

const WORKSPACE_RECORDS: readonly WorkspaceRecordContext[] = [
  {
    id: "people-students",
    label: "Student Management",
    product: "exxat-people",
    icon: "fa-user-graduate",
  },
  {
    id: "people-faculty",
    label: "Faculty Management",
    product: "exxat-people",
    icon: "fa-chalkboard-user",
  },
]

/** Active workspace record hub from a `/people/*` app-screen route, if any. */
/** Font Awesome tile glyph for a workspace record hub row. */
export function workspaceRecordGlyphIcon(icon: string): string {
  return solidTileGlyphIcon(icon)
}

export function workspaceRecordFromPathname(pathname: string): WorkspaceRecordContext | null {
  for (const record of WORKSPACE_RECORDS) {
    const href =
      record.id === "people-students" ? "/people/students" : "/people/faculty"
    if (pathname === href || pathname.startsWith(`${href}/`)) {
      return record
    }
  }
  return null
}
